"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeUserData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const form_1 = require("../../molecules/form/form");
const form_2 = require("../../atoms/form");
const buttons_1 = require("../../atoms/buttons");
const Modal_1 = require("./Modal");
const form_3 = require("../../atoms/form");
const moment_1 = __importDefault(require("moment"));
var formKeys;
(function (formKeys) {
    formKeys["firstName"] = "firstName";
    formKeys["lastName"] = "lastName";
    formKeys["birthDate"] = "birthDate";
    formKeys["street"] = "street";
    formKeys["streetNumber"] = "streetNumber";
    formKeys["postcode"] = "postcode";
    formKeys["place"] = "place";
    formKeys["country"] = "country";
    formKeys["phoneNumber"] = "phoneNumber";
})(formKeys || (formKeys = {}));
const ChangeUserData = ({ onCloseModal, onSubmit, user, countries, isPhoneNumberValid = () => true, userDateFormat }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { t } = (0, react_i18next_1.useTranslation)("md");
    const { handleSubmit, register, formState: { errors }, setFocus } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            firstName: user.firstName,
            lastName: user.lastName,
            birthDate: (0, moment_1.default)(user.birthDate, userDateFormat).format("YYYY-MM-DD"),
            street: user.address.streetName,
            streetNumber: user.address.streetNumber,
            postcode: user.address.postCode,
            place: user.address.city || "",
            country: user.address.country,
            phoneNumber: user.phoneNumber
        }
    });
    const validateInputValue = (val) => {
        if ((val === null || val === void 0 ? void 0 : val.trim()) === "") {
            return t("errors.inputEmpty");
        }
        return true;
    };
    (0, react_1.useEffect)(() => {
        setFocus(formKeys.firstName);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { title: t("userDataModal.title"), variant: "small", children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)(form_1.Form, { variant: "vertical", onSubmit: handleSubmit(onSubmit), children: [(0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.name") + "*" }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(form_2.Input, { err: (_a = errors[formKeys.firstName]) === null || _a === void 0 ? void 0 : _a.message, ...register(formKeys.firstName, {
                                    required: { value: true, message: t("errors.inputEmpty") },
                                    validate: validateInputValue
                                }) }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_b = errors[formKeys.lastName]) === null || _b === void 0 ? void 0 : _b.message, ...register(formKeys.lastName, {
                                    required: { value: true, message: t("errors.inputEmpty") },
                                    validate: validateInputValue
                                }) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.birthDate") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { placeholder: user.birthDate, icon: ["fas", "calendar"], type: "date", err: (_c = errors[formKeys.birthDate]) === null || _c === void 0 ? void 0 : _c.message, ...register(formKeys.birthDate, {
                            required: { value: true, message: t("errors.inputEmpty") },
                            validate: validateInputValue
                        }) }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.street") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_d = errors[formKeys.street]) === null || _d === void 0 ? void 0 : _d.message, ...register(formKeys.street, {
                                            required: { value: true, message: t("errors.inputEmpty") },
                                            validate: validateInputValue
                                        }) }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.streetNumber") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_e = errors[formKeys.streetNumber]) === null || _e === void 0 ? void 0 : _e.message, ...register(formKeys.streetNumber, {
                                            required: { value: true, message: t("errors.inputEmpty") },
                                            validate: validateInputValue
                                        }) }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.postcode") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_f = errors[formKeys.postcode]) === null || _f === void 0 ? void 0 : _f.message, ...register(formKeys.postcode, {
                            required: { value: true, message: t("errors.inputEmpty") },
                            validate: validateInputValue
                        }) }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.place") }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_g = errors[formKeys.place]) === null || _g === void 0 ? void 0 : _g.message, ...register(formKeys.place) }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.country") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_3.Select, { options: countries, error: errors.country && t("errors.inputEmpty"), ...register(formKeys.country, {
                            required: { value: true, message: t("errors.inputEmpty") }
                        }) }, void 0), (0, jsx_runtime_1.jsx)("label", { children: t("userDataModal.phoneNumber") + "*" }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { err: (_h = errors[formKeys.phoneNumber]) === null || _h === void 0 ? void 0 : _h.message, type: "tel", ...register(formKeys.phoneNumber, {
                            required: { value: true, message: t("errors.inputEmpty") },
                            validate: isPhoneNumberValid
                        }) }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "submit", hidden: true }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", onClick: onCloseModal, children: t("userDataModal.cancel") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { type: "submit", variant: "primary", children: t("userDataModal.submit") }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.ChangeUserData = ChangeUserData;
const Wrapper = styled_components_1.default.div `
  form {
    margin-bottom: 0;
  }

  form > div > input::placeholder {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }

  form div:first-of-type {
    display: flex;

    & > div {
      flex: 1;
      margin-top: 0;
    }

    & div input {
      height: 2.25rem;
    }

    & > div {
      flex-direction: column;
    }

    & > div:first-of-type {
      margin-right: ${({ theme }) => theme.spacings.xs};
    }
  }

  form > div:nth-of-type(3) {
    display: flex;
    width: 100%;

    & > div {
      display: flex;
      flex: 1;
      flex-direction: column;

      & > div {
        flex-direction: column;
      }
    }
  }

  form > div:last-of-type {
    display: flex;
    margin-top: ${({ theme }) => theme.spacings.xxl};
    width: 100%;

    button {
      margin-bottom: 0;
    }

    & > button:first-of-type {
      margin-right: ${({ theme }) => theme.spacings.s};
    }
  }

  select {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=ChangeMemberData.js.map